import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { collection, doc, updateDoc, deleteDoc, addDoc} from 'firebase/firestore';
import { auth, db } from "../../firebase";
import { CountriesDB } from '../db/CountriesDB';

import "./Countries.css";

const Countries = () => {
  const [countries, setCountries] = useState([]);
  const [name, setName] = useState('');
  const [abr, setAbr] = useState('');
  const [path, setPath] = useState('');
  const [idCountry, setIdCountry] = useState('')

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const PAGE_SIZE = 10;

  useEffect(() => {

    if (!user) return navigate("/")

    CountriesDB.getAll().then(countriesData => {
      setCountries(countriesData)
    })
  }, [user,navigate]);

  const columns = [
    {
      name: 'Nombre',
      selector: row => row['name'],
      sortable: true,
    },
    {
      name: 'Abreviatura',
      selector: row => row['abr'],
      sortable: true,
    },
    {
      name: 'Logo',
      cell:(row) => <img height="30em" src={`./assets/flags/${row['path']}`} alt={row['path']}/>,
      sortable: false,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEditar(e, row)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"/><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEliminar(e, row.id)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="m17,4v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2h-6Zm-8-2h6v2h-6v-2Zm6.957,14.543l-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414,2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const handleGuardar = async () => {
    const newCountry = {
      name: name,
      abr: abr,
      path: path,
    };
    if (idCountry === '') {
      try {
        const docRef = await addDoc(collection(db, 'countries'), newCountry)
        setCountries([...countries, { id: docRef.id, ...newCountry }])
        handleLimpiar()
      } catch (error) {
        console.error('Error al agregar el pais:', error)
      }
    } else {
      try {
        const countryRef = doc(db, 'countries', idCountry)
        await updateDoc(countryRef, newCountry)
        const newCountries = [...countries]
        const index = newCountries.map(e => e.id).indexOf(idCountry)
        newCountry.id=idCountry
        newCountries[index] = newCountry
        setCountries(newCountries)
        handleLimpiar()
      } catch (error) {
        console.error('Error al modificar el pais:', error);
      }
    }
  };

  const handleEditar = (event, row) => {
    setName(row.name)
    setAbr(row.abr)
    setPath(row.path)
    setIdCountry(row.id)
  };

  const handleEliminar = async (event, id) => {
    if (window.confirm("Está seguro que desea eliminar el pais?")) {
      const countryRef = doc(db, 'countries', id)
      await deleteDoc(countryRef)
      const newCountries = countries.filter(country => country.id !== id)
      setCountries(newCountries)
    }
  };

  const handleLimpiar = () => {
    setName('')
    setAbr('')
    setPath('')
    setIdCountry('')
  }

  return (
    <div className="container-countries"> 
      <h2>Países</h2>
      
      <h3>Agregar países</h3>
      <input
        type="text"
        placeholder="Nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Abreviatura"
        value={abr}
        onChange={(e) => setAbr(e.target.value)}
      />
      <input
        type="text"
        placeholder="Path bandera"
        value={path}
        onChange={(e) => setPath(e.target.value)}
      />
      <button onClick={handleGuardar}>Guardar</button>
      <button onClick={handleLimpiar}>Limpiar</button>
      <div className="table">
        <DataTable
          columns={columns}
          data={countries}
          pagination
          paginationTotalRows={countries.length}
          paginationPerPage={PAGE_SIZE}
          paginationRowsPerPageOptions={[PAGE_SIZE]}
      />
      </div>
    </div>
  );
};

export default Countries;